import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import InputMask from '@mona-health/react-input-mask';
import { Input } from '../../Input';
const EXP_DATE_REGEX = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
export const ExpDateInput = ({ control, name, size, disabled, dataTestId, className, inputClassName, onFocus, onBlur }) => {
    const { field, fieldState } = useController({
        name,
        control,
        rules: {
            required: {
                value: true,
                message: 'Exp date is required'
            },
            pattern: {
                value: EXP_DATE_REGEX,
                message: 'Exp date format must be MM/YY'
            },
            validate: (value) => {
                if (!value) {
                    return 'Invalid exp date';
                }
                const [monthStr, yearStr] = value?.split('/');
                const month = parseInt(monthStr, 10);
                const year = parseInt(yearStr, 10);
                const currentDate = new Date();
                const currentYear = currentDate.getFullYear() % 100;
                const currentMonth = currentDate.getMonth() + 1;
                if (year < currentYear || (year === currentYear && month < currentMonth)) {
                    return 'Invalid exp date';
                }
                return true;
            }
        }
    });
    const hasErrors = fieldState.error;
    return (_jsx(InputMask, { mask: "99/99", ...field, disabled: disabled, maskPlaceholder: null, ref: null, type: "tel", onBlur: (e) => {
            field.onBlur();
            onBlur?.(e);
        }, onFocus: onFocus, children: _jsx(Input, { autoComplete: name, className: className, dataTestId: dataTestId, disabled: disabled, errors: hasErrors, inputClassName: inputClassName, isSuccess: field.value && !hasErrors, placeholder: "MM/YY", ref: field.ref, size: size, type: "tel" }) }));
};
